/* eslint-disable camelcase */
export default {
  show_as_grid: 'Режим таблицы',
};
